import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Puts a text over the center of the parent block.
function OverlayMessage({ text, textSize }) {
  const [t] = useTranslation();

  return (
    <div className="position-absolute top-50 start-50 translate-middle">
      <span className="text-black fw-bold" style={{ fontSize: textSize }}>
        {t(text)}
      </span>
    </div>
  );
}

OverlayMessage.defaultProps = {
  textSize: 40
};

OverlayMessage.propTypes = {
  textSize: PropTypes.number,
  text: PropTypes.string.isRequired
};

export default OverlayMessage;
